import * as React from "react";
const Figures = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={864} height={904} fill="none" {...props}>
        <rect
            width={923.433}
            height={923.433}
            x={1231.76}
            y={398.96}
            fill="#00A2CF"
            opacity={0.05}
            rx={68.403}
            transform="rotate(115.597 1231.76 398.96)"
        />
        <rect
            width={749.034}
            height={749.034}
            x={1295.29}
            y={326.479}
            fill="#00A2CF"
            opacity={0.05}
            rx={55.484}
            transform="rotate(115.597 1295.29 326.479)"
        />
    </svg>
);
export default Figures;
